"use client";

import servicesConfig from "./config/index";

import ERPServiceLayout from "./layouts/ERPServiceLayout";
import AIServiceLayout from "./layouts/AIServiceLayout";
import MobileAppLayout from "./layouts/MobileAppLayout";
import WebAppLayout from "./layouts/WebAppLayout";
import UiUxServiceLayout from "./layouts/UiUxServiceLayout";


const ServiceDetails = ({ slug }) => {
  const data = servicesConfig?.[slug];

  if (!data) return null;

  if (slug === "odoo-erp-implementation") {
    return <ERPServiceLayout data={data} />;
  }

  if (slug === "ai-implementation") {
    return <AIServiceLayout data={data} />;
  }

   if (slug === "web-app-development") {
    return <WebAppLayout data={data} />;
  }

   if (slug === "mobile-app-development") {
    return <MobileAppLayout data={data} />;
  }

    if (slug === "ui-ux-design") {
    return <UiUxServiceLayout data={data} />;
  }

  return null;
};

export default ServiceDetails;
